import { action, computed, makeObservable } from 'mobx';

import { IFormStore } from '@/stores/interfaces/IFormStore';
import { OptionEntity } from '@/types/OptionEntity';

import { BaseFieldSelectStore } from './BaseFieldSelectStore';
import { FieldSelectStoreOptions } from './types';

export class FieldSelectMultiStore<V extends OptionEntity = OptionEntity>
  extends BaseFieldSelectStore<V>
  implements IFormStore<any, V['key'][]>
{
  constructor(options: FieldSelectStoreOptions<V>) {
    super(options);

    makeObservable(this, {
      serverFormat: computed.struct,
      setFromServerFormat: action.bound,
      setFromQueryFormat: action.bound,
    });
  }

  /**
   * Возвращает серверный формат значение поле
   * @returns {ToServerData} результат для отправки на сервер
   */
  get serverFormat(): V['key'][] {
    return this.value.map(({ key }) => key);
  }

  /**
   * Заполняет значение поле из серверных данных
   * @param from серверные данные
   */
  setFromServerFormat(): void {
    // TODO
  }

  setFromQueryFormat(from: string | string[]): void {
    const arrayFrom = Array.isArray(from) ? from : [from];

    this.setValue(
      arrayFrom.map((v) => ({ key: v.toString(), value: '' }) as V),
      { noTouch: true },
    );

    this.syncValueByKeys(arrayFrom);
  }
}
